import Carousel from "../../../../components/Carousel/Carousel";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { locale } from "../../../../utilities/locale/locale";
import ProductCard from "../../../ProductInfo/components/ProductCard/ProductCard";
import useSectionProducts from "../../hooks/useSectionProducts";
import HeaderSection from "../HeaderSection/HeaderSection";
import ProductCardMobile from "../../../ProductInfo/components/ProductCard/ProductCardMobile";
import { MediaQuery } from "react-responsive";
import ProductSectionsLoading from "../ProductSectionsLoading/ProductSectionsLoading";
import useLoadingSimulation from "../../hooks/useLoadingSimulation";

const defaultBreakpoints = {
  350: {
    slidesPerView: 1.5,
    spaceBetween: 0,
  },
  520: {
    slidesPerView: 3,
    spaceBetween: 0,
  },
  768: {
    slidesPerView: 4,
    spaceBetween: 0,
  },
};

const ProductTemplate = ({ product }) => {
  return (
    <div className="flex" style={{ flexBasis: "100%", flexGrow: 1, minHeight: "100%" }}>
      <MediaQuery query="(max-width: 768px)">
        {(matches) =>
          matches ? <ProductCardMobile product={product} /> : <ProductCard product={product} />
        }
      </MediaQuery>
    </div>
  );
};

const SectionProducts = ({ section }) => {
  const isLoadingSimulation = useLoadingSimulation();
  const titleOptions = {
    en: section.sectiondescriptionEnglish,
    it: section.sectiondescriptionItalian,
    pt: section.sectiondescriptionPortuguese,
    es: section.sectiondescriptionSpanish,
  };

  const currentTitle = titleOptions[locale]?.toLowerCase() ?? null;

  const { showErrorToast } = useToastContext();
  const { isLoading, products } = useSectionProducts({
    endpoint: section.endpoint,
    onError: (code) => showErrorToast({ code }),
  });

  if (isLoading) {
    return (
      <div className="my-8">
        <ProductSectionsLoading />
      </div>
    );
  }

  return (
    <section className="mx-auto lg:my-7 my-4 w-full mx-0">
      {products.length > 0 && (
        <>
          <div style={{ marginBottom: "-8px" }}>
            <HeaderSection>{currentTitle}</HeaderSection>
          </div>

          <Carousel
            breakpoints={defaultBreakpoints}
            items={products.map((product) => (
              <ProductTemplate product={product} />
            ))}
          />
        </>
      )}
    </section>
  );
};

export default SectionProducts;
